module.exports = __webpack_public_path__ + "static/media/info-circle.fbfd7fed.svg";